import { TDeviceType } from '@cian/ui-kit';
import { EDealType } from '../dealType';
import { IParsedQsParams } from '../expectedQsParams';
import * as React from 'react';

export enum EPageType {
  // Обычный отчет об оценке квартиры (пользователь агент)
  ReportCreator = 'reportCreator',
  // Страница готового (статического) отчета об оценке квартиры
  ReportReady = 'reportReady',
  // Обычный отчет об оценке квартиры (пользователь поискун)
  Calculator = 'calculator',
  // Мой дом квартира вторичка
  MyHomeDetailed = 'MyHomeDetailed',
  // Обычный отчет об оценке загородки (дом/участков)
  CalculatorSuburban = 'CalculatorSuburban',
  // Мой дом загородка (дом/участок)
  MyHomeSuburbanDetailed = 'MyHomeSuburbanDetailed',
}

export interface IRenderOptions {
  children: React.ReactElement;
  onCTAClose: () => void;
}

export interface IPageCTAComponentProps {
  /**
   * render-функция необходима для пробрасывания функционала внутрь PageCTAContainer
   * @see PageCTAContainer
   **/
  render(options: IRenderOptions): React.ReactElement;
}

/** Компонент, предназначенный для использования в CTA, должен использовать render-пропс */
export type TPageCTAComponent = React.ComponentType<IPageCTAComponentProps>;

export interface IPageCTA {
  isOpen: boolean;
  Component?: TPageCTAComponent;
  onClose?(): void;
  title?: string;
}

export interface IPageState {
  deviceType: TDeviceType;
  dealType: EDealType;
  pageType: EPageType;
  subdomain: string;
  /** Набор query параметров страницы. Изменение этого поля в сторе отражается в изменении параметров в URL */
  queryParams: IParsedQsParams;
  isWebview: boolean;
  stickyFooterVisible: boolean;
  cta: IPageCTA;
  isFromOfferCard: boolean;
  isFromMyHome: boolean;
  minGeoId?: number;
}
